import { Component, OnInit } from '@angular/core';
import { ParamService } from '@client/ng2/core/param/param.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-summary',
    templateUrl: './summary.component.html',
    standalone: false,
})
export class StatisticsVisitorsSummaryComponent implements OnInit {
    domain: any;
    date: any;

    constructor (
        private ng2ParamService: ParamService,
        private ng2SessionService: SessionService,
        private dateRangeService: DateRangeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.ng2SessionService.domain;
        this.date = this.dateRangeService.setRangeDates();
        this.updateDateRange();
    }

    updateDateRange () {
        this.ng2ParamService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
        });
    }
}
